type DownloadFileIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const DownloadFileIcon = (props: DownloadFileIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M10.0003 8.00008V10.0001H2.00033V8.00008H0.666992V10.0001C0.666992 10.7334 1.26699 11.3334 2.00033 11.3334H10.0003C10.7337 11.3334 11.3337 10.7334 11.3337 10.0001V8.00008H10.0003ZM9.33366 5.33341L8.39366 4.39341L6.66699 6.11341V0.666748H5.33366V6.11341L3.60699 4.39341L2.66699 5.33341L6.00033 8.66675L9.33366 5.33341Z"
      fill="currentColor"
    />
  </svg>
);
